import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../apiConfig';
import TeamCard from '../../../Components/Team/TeamCard';

const DIVISION_ID = '128428';

const TeamsTab = () => {
    const [teams, setTeams] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchTeams = async () => {
            try {
                const res = await axios.get(`${API_BASE_URL}/divisionTeam/${DIVISION_ID}`);
                setTeams(res.data || []);
            } catch (err) {
                console.error("Error fetching teams:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchTeams();
    }, []);

    if (loading) return <div className="loader" style={{ margin: '50px auto' }}></div>;

    const styles = {
        grid: {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'flex-start',
            gap: '32px',
            width: '100%',
            padding: '20px 0'
        }
    };

    return (
        <div style={styles.grid}>
            {teams.length > 0 ? teams.map((team, i) => (
                <TeamCard key={i} data={team} league="100 BALLS" />
            )) : (
                <p style={{ fontFamily: 'var(--fontRajdhani)', fontSize: '18px', color: '#666' }}>No teams registered for this tournament yet.</p>
            )}
        </div>
    );
};

export default TeamsTab;
